import { render, staticRenderFns } from "./ValTiposDocumentosView.vue?vue&type=template&id=6eb16dd2&"
import script from "./ValTiposDocumentosView.vue?vue&type=script&lang=js&"
export * from "./ValTiposDocumentosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports